import {Box, Card, Center, Loader, SimpleGrid, Text, Title} from "@mantine/core";
import type {LibraryStats, StudyStats} from "@/app/storage";

export function ProgressStats(props: {
  libraryStats: LibraryStats | null;
  studyStats: StudyStats | null;
  isLoading: boolean;
}) {
  const {libraryStats, studyStats, isLoading} = props;
  if (isLoading) {
    return (
      <Card withBorder radius="lg" p="xl" className="glass-card" bg="transparent">
        <Center p="xl">
          <Loader size="lg" />
        </Center>
      </Card>
    );
  }

  const stats = [
    {
      label: "Total Items",
      value: libraryStats?.totalEntries ?? 0,
      icon: "📚",
      color: "teal",
    },
    {
      label: "Due for Review",
      value: libraryStats?.dueForReview ?? 0,
      icon: "⏰",
      color: "orange",
    },
    {
      label: "Study Streak",
      value: `${studyStats?.currentStreak ?? 0} days`,
      icon: "🔥",
      color: "red",
    },
    {
      label: "Total Sessions",
      value: studyStats?.totalSessions ?? 0,
      icon: "✨",
      color: "teal",
    },
  ];

  return (
    <Card withBorder radius="lg" p="xl" className="glass-card" bg="transparent">
      <Title order={3} size="h4" mb="xl">
        Your Progress
      </Title>

      <SimpleGrid cols={{base: 2, sm: 4}} spacing="lg">
        {stats.map(stat => (
          <Box
            key={stat.label}
            p="md"
            ta="center"
            style={{
              borderRadius: "var(--mantine-radius-md)",
              background:
                "light-dark(var(--mantine-color-gray-0), rgba(255, 255, 255, 0.03))",
              transition: "all 0.3s ease",
            }}
          >
            <Text size="xl" mb="xs">
              {stat.icon}
            </Text>
            <Text size="xl" fw="bold" c={stat.color} mb={4}>
              {stat.value}
            </Text>
            <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
              {stat.label}
            </Text>
          </Box>
        ))}
      </SimpleGrid>
    </Card>
  );
}
